<template>
  <div class="">
    <div v-for="tweet in tweets">
    <h4 class="title is-4"><b-icon icon="twitter"></b-icon> Latest Tweet</h4>
      <h5 class="subtitle is-5"><a target="_blank" :href="twitterHandleLink(tweet['user'])">@{{tweet['user']}}</a></h5>
      <p v-html="linkTwitterHandles(tweet['text'])"></p>
    </div>
  </div>
</template>

<script>
  import BIcon from "buefy/src/components/icon/Icon";
  import SocialService from "@/service/SocialService"
  export default {
    name: "LatestTweet",
    components: {BIcon},
    data() {
      return {
        tweets:[]
      }
    },
    computed: {
    },
    methods: {
      getTweets(){
        SocialService.getTweets(null,1).then((response)=>{
          this.tweets = response.data
        })
      },
      twitterHandleLink(handle){
        return `https://twitter.com/${handle}`
      },
      linkTwitterHandles(textBlock){
        const regex = /\@[A-z]+/gm;
        const subst = `<a target="_blank" href="https://www.twitter.com/$&">$&</a>`;
        return textBlock.replace(regex, subst);
      }
    },
    mounted() {
      this.getTweets()
    }
  }
</script>